import {Box, BoxProps, Heading, HeadingProps} from '@chakra-ui/react'
import {ReactNode} from 'react'

export interface DataSectionProps extends BoxProps {
  label?: ReactNode
  labelAs?: React.ElementType
  size?: HeadingProps['size']
}

export function DataSection({label, children, labelAs = 'h4', size = 'md', ...props}: DataSectionProps) {
  return (
    <Box as="section" spaceY="5" {...props}>
      {label && (
        <Heading as={labelAs} fontSize={size} fontWeight="medium" fontFamily="body">
          {label}
        </Heading>
      )}

      {children}
    </Box>
  )
}
